import {NgModule} from '@angular/core';
import {IonicModule} from 'ionic-angular';

import {ScheduleModalComponent} from './index';

/**
 * Module for the Schedual modal
 */
@NgModule({
  declarations: [ScheduleModalComponent],
  entryComponents: [ScheduleModalComponent],
  exports: [ScheduleModalComponent],
  imports: [IonicModule],
  providers: [],
})
export class ScheduleModalModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/schedule-modal/schedule-modal.module.ts